var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download-fill",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.38,
    height: 30.83,
    viewBox: "0 0 31.38 30.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4634",
    "data-name": "Rectangle 4634",
    width: 11.011,
    height: 2.202,
    rx: 1,
    fill: "#4b83fe",
    stroke: "#4b83fe",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34230",
    "data-name": "Group 34230",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15718",
    "data-name": "Group 15718",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3901",
    "data-name": "Rectangle 3901",
    transform: "translate(0.551)",
    fill: "none",
    stroke: "#4b83fe",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.83,
    height: 30.83,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29.83,
    height: 29.83,
    rx: 2.5,
    fill: "none"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "download-fill-2",
    "data-name": "download-fill",
    transform: "translate(7.707 7.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M0,0H16.031V16.031H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M3.875,13.315H15.9v1.336H3.875Zm6.68-6.68h4.676L9.887,11.979,4.543,6.635H9.219V1.292h1.336Z",
    transform: "translate(-1.871 -0.624)",
    fill: "#4b83fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFill);
export default __webpack_public_path__ + "static/media/download-fill.c1d0433a.svg";
export { ForwardRef as ReactComponent };